import { Action } from '@ngrx/store';
import { EfectorData } from '../models/store.model';


export const SETEFECTORDATA = '[EfectorData] Set Efector Data';
export const UNSETEFECTORDATA = '[EfectorData] Unset Efector Data';

export class SetEfectorData implements Action {
    readonly type = SETEFECTORDATA;
    constructor(public efector: EfectorData) { }
}

export class UnsetEfectorData implements Action {
    readonly type = UNSETEFECTORDATA;
}

export type EfectorDataActions =
    | SetEfectorData
    | UnsetEfectorData;
